import { TransformNS } from "../../../../../../Transform/TransformNS.js";
export const _getSelectionScaleTransform2Throwable = (self) => {
  if (self._selection_scale_transform2 == null) {
    throw new Error(
      `selection_scale_transform2 가 없습니다. 앱 초기화를 진행해주세요.`
    );
  }
  return self._selection_scale_transform2;
};
